
import { DEAL_PLACEHOLDER_IMG } from '@/constants/global';
import get from 'lodash/get';
import BlackFridayBadge from '~/static/campaigns/black-friday-badge.svg?inline';
import SumoDayBadge from '~/static/sumoday-badge.svg?inline';
import DealBanner from '../utilities/DealBanner.vue';
import CampaignsMixin from '~/mixins/campaigns';

export default {
  components: {
    BlackFridayBadge,
    SumoDayBadge,
    DealBanner,
  },
  filters: {
    fullstop(value) {
      if (!value) {
        return '';
      }

      if (value && value.length && value.substr(-1, 1) === '.') {
        return value;
      }

      return `${value}.`;
    },
  },
  mixins: [CampaignsMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
    deals: {
      type: Array,
      required: true,
    },
    more: {
      type: String,
      required: true,
    },
    component: {
      type: Object,
      required: true,
    },
  },
  computed: {
    lazyPlaceholderImage() {
      return DEAL_PLACEHOLDER_IMG;
    },
    carouselOptions() {
      return {
        prevNextButtons: true,
        adaptiveHeight: true,
      };
    },
    isPromo() {
      return !!this.component.background;
    },
    campaigns() {
      if (this.$store && this.$store.getters) {
        return this.$store.getters.campaigns || [];
      }
      return [];
    },
  },
  methods: {
    backgroundClick(e) {
      if (e.target.nodeName.toLowerCase() !== 'a') {
        window.location = this.more;
      }
    },
    generateCardDescription(deal) {
      return get(deal, 'card_description');
    },
  },
};
